<section class="content-layout">
  <bw-action-article-legacy [brightsideWebFb]="{ event_name: this.analyticsAttributes.event_name }">
    <bw-icon-legacy
      *ngIf="campaign.closeable && campaign.secondaryCtaPath"
      iconName="close"
      size="24"
      [brightsideWebFb]="{ event_name: this.analyticsAttributes.event_name }"
      (click)="handleClick(campaign.secondaryCtaPath, CampaignEventStatus.FAILED)"
    ></bw-icon-legacy>

    <!-- We need to sort out these buttons... needed to add this one to support micro app (mobile) -->
    <div header-actions class="flex-row pointer" *ngIf="campaign.closeable">
      <bw-icon-legacy class="hidden-desktop" iconName="close" size="24" (click)="handleCloseClick()"></bw-icon-legacy>
    </div>

    <ui-nav-exit-back
      *ngIf="!campaign.closeable && showBackArrow"
      back-action-bottom
      [infoLabel]="campaign.backButtonLabel ?? 'BACK_WEB'"
      [trackingDetail]="{ event_name: this.analyticsAttributes.event_name }"
      (exitActionHandler)="handleClick(campaign.secondaryCtaPath, CampaignEventStatus.FAILED, 'back')"
      [showBackArrow]="campaign.backButtonLabel !== 'BUTTON_SKIP'"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column mb-sm" [ngClass]="{ 'space-center': alignContentToCenter }">
        <div class="align-left">
          <img src="../assets/{{ imageName }}.svg" [alt]="imageName" class="mb-md" />
          <p title-medium class="mb-sm">{{ titleText || campaign.titleKey | translate }}</p>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p [ngClass]="bodyTextAlign" [style.whiteSpace]="bodyTextNoWrap" style="max-width: 432px">
              {{ bodyText || campaign.textBodyKey | translate }}
            </p>
          </typography-legacy>
        </div>
      </div>
    </div>

    <div content-section *ngIf="campaign.isCreditIntro">
      <div class="flex-column space-center mb-xl">
        <div class="align-left">
          <typography-legacy text-large-regular
            ><strong>{{ 'CREDIT_INTRO_SUBHEADER' | translate }}</strong></typography-legacy
          >
          <div class="mt-sm mb-sm">
            <div *ngFor="let item of creditIntroItems" class="flex-row space-between">
              <div class="align-left mr-sm">
                <bw-icon-legacy [iconName]="'checkmark'" size="24"></bw-icon-legacy>
              </div>
              <div class="flex-column flex-item-flexible">
                <typography-legacy text-medium-regular>{{ item | translate }}</typography-legacy>
              </div>
            </div>
          </div>
          <div class="mb-sm">
            <typography-legacy text-large-regular color="var(--secondary-text)">
              <p class="left" style="max-width: 432px">
                {{ 'CREDIT_INTRO_HALFSHEET_DESC' | translate }}
              </p>
            </typography-legacy>
          </div>
        </div>
      </div>
    </div>

    <div content-section *ngIf="campaign.listItems?.length">
      <div class="flex-column mb-xl">
        <div class="align-left">
          <typography-legacy text-large-regular
            ><strong>{{ campaign.listSubHeader || '' | translate }}</strong></typography-legacy
          >
          <div class="mt-sm mb-sm">
            <div *ngFor="let item of campaign.listItems" class="flex-row space-between">
              <div class="align-left mr-sm">
                <bw-icon-legacy [iconName]="'checkmark'" size="24"></bw-icon-legacy>
              </div>
              <div class="flex-column flex-item-flexible">
                <typography-legacy text-medium-regular>{{ item | translate }}</typography-legacy>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div footer-actions [ngClass]="{ 'flex-column': campaign.showFullScreenCta }">
      <button
        *ngIf="campaign.ctaKey || primaryCtaText"
        bw-button-legacy
        type="submit"
        [brightsideWebFb]="{ event_name: this.analyticsAttributes.event_name }"
        [processing]="processing"
        (click)="handleClick(campaign.ctaPath, CampaignEventStatus.SUCCESS)"
      >
        {{ primaryCtaText || campaign.ctaKey | translate }}
      </button>

      <button
        *ngIf="campaign.secondaryCta"
        bw-link-button-legacy
        [brightsideWebFb]="{ event_name: this.analyticsAttributes.event_name }"
        [dismissedCta]="true"
        (click)="handleClick(campaign.secondaryCtaPath, CampaignEventStatus.FAILED)"
      >
        {{ secondaryCtaText || campaign.secondaryCtaKey | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>
